import { render, staticRenderFns } from "./IndexCompact.vue?vue&type=template&id=50542adf&"
import script from "./IndexCompact.vue?vue&type=script&lang=js&"
export * from "./IndexCompact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./IndexCompact.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports